import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { io } from 'socket.io-client';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css']
})
export class ManualComponent implements OnInit {

  data_manual = [] as any;
  pdfDownload: any;
  pdfView: any;
  pdfName:any;
  displayList: boolean = true;
  displayPdf: boolean = false;
  page = 1;
  count = 0;
  tableSize = 15;
  visitor: any = [];
  socket: any;

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    this.getDataAll();
    // this.socket = io('https://ogc.mapedia.co.th/api/v2/lrfund/');
    this.services.get('m_countofuser').then((res: any) => {
      this.getCounter(res);
    })
    // this.socket.on('output', (res: any) => {
    //   this.getCounter(res);
    // });
  }

  getDataAll() {
    this.services.getByType('manual').then((res: any) => {
      this.getManual(res);
    });
  }

  getManual(data:any){
    data.forEach((file:any) => {
      if( file.status == 'Enable') {
        this.data_manual.push(file);
      }
    });
  }

  onClickDownload(file_name:any, name:any){
    this.pdfDownload = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/"+file_name;
    FileSaver.saveAs(this.pdfDownload, name);
  }
  onClickView(file_name:any, name:any){
    this.displayList = false;
    this.displayPdf = true;
    this.pdfName = name;
    this.pdfView = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/"+file_name;
  }
  onClickClose(){
    this.displayList = true;
    this.displayPdf = false;
  }
  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  async getCounter(data:any) {
    let counnt_visitor = (data.length).toString()
    this.visitor = [];
    for (let j = 0; j < counnt_visitor.length; j++) {
      this.visitor.push(counnt_visitor[j])
    }
    for (let x = 0; x < 6; x++) {
      if (this.visitor.length < 6) {
        this.visitor.splice(0, 0, 0);
      }
    }
  }
}
